// import Swiper JS
import Swiper from 'swiper';
import { Navigation,Pagination, Autoplay, Mousewheel, Thumbs } from 'swiper/modules';
/* import "animate.css" */

const $ = window.jQuery;

const productSwiper = {
	mainSwiper: null,
	thumbsSwiper: null,
	playVid(vidEl) {
		vidEl.pause();
		vidEl.currentTime = 0;
		vidEl.load();
		vidEl.play();
	},

	pauseVid(vidEl) {
		vidEl.pause();
	},
	init() {
		const $productSwiper = $(document).find('#yg-product-swiper');
		if (!$productSwiper.length) return;

		const $slides = $productSwiper.find('.swiper-slide');
		if (!$slides.length) return;

		$.fn.wc_variations_image_update = (variation) => {
			console.log('variation', variation);
			const image_id = variation.image_id;

			// thumb gallery
			const thumb_gallery = $(document).find('#yg-product-swiper__nav');

			if (!thumb_gallery) return;

			// Assuming $productSwiper is correctly initialized and points to the main swiper's DOM element
			const mainSwiper = $productSwiper.get(0).swiper;

			// Check if a default variation is selected
			if (!variation) {
				// Navigate both swipers to the first slide
				if (mainSwiper) {
					mainSwiper.slideTo(0);
				}
				const thumbSwiperInstance = thumb_gallery.get(0).swiper;
				if (thumbSwiperInstance) {
					thumbSwiperInstance.slideTo(0);
				}
				return; // Exit the function early
			}

			// find thumb with image_id
			const $thumb = thumb_gallery.find(`[data-image-id="${image_id}"]`);

			// if thumb exists
			if ($thumb[0]) {
				console.log('found thumb', $thumb);
				console.log('found thumb parent', $thumb.parent());
				// Assuming the swiper instance for the thumbnail navigation is stored in a data attribute of the swiper container
				const thumbSwiperInstance = thumb_gallery.get(0).swiper;

				// Find the index of the slide that needs to be displayed
				const slideIndex = $thumb.parent().index();

				// Change to the slide with the found index in the thumbnail navigation
				if (thumbSwiperInstance) {
					thumbSwiperInstance.slideTo(slideIndex);
				}

				// Change to the corresponding slide in the main slider
				if (mainSwiper) {
					mainSwiper.slideTo(slideIndex);
				}
			}
		};

		Swiper.use([Navigation, Autoplay, Mousewheel, Thumbs]);

		const YGthis = this;

		this.mainSwiper = new Swiper('#yg-product-swiper', {
			slidesPerView: 1,
			spaceBetween: 0,
			cache: false,
			loop: false,
			center: true,
			resizeObserver: true,
			autoHeight: true, //enable auto height
			autoplay: false,
			watchSlidesProgress: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			thumbs: {
				swiper: this.thumbsSwiper,
			},
			on: {
				init: function () {
					var swiperThis = this;
					var index = this.activeIndex;
					var currentSlide = $(this.slides[index]);
					var currentSlideType = currentSlide.attr('data-type');
					if (currentSlideType == 'video') {
						var vidEl = currentSlide.find('video');
						YGthis.playVid(vidEl[0]);

						vidEl.one('ended', function () {
							swiperThis.autoplay.run();
							swiperThis.slideNext();
						});
					}
				},
				slideChange: function () {
					var index = this.activeIndex;
					var currentSlide = $(this.slides[index]);

					var currentSlideType = currentSlide.attr('data-type');
					if (currentSlideType == 'video') {
						var vidEl = currentSlide.find('video');
						YGthis.playVid(vidEl[0]);
						this.autoplay.stop();
					} else {
						$(this)
							.find('video')
							.each(function () {
								YGthis.pauseVid(this[0]);
							});
					}
				},
			},
		});
	},
	initNav() {
		const $productSwiperNav = $(document).find('#yg-product-swiper__nav');
		if (!$productSwiperNav.length) return;

		const $slides = $productSwiperNav.find('.swiper-slide');
		if (!$slides.length) return;

		Swiper.use([Navigation, Autoplay, Mousewheel,Pagination]);

		this.thumbsSwiper = new Swiper('#yg-product-swiper__nav', {

			spaceBetween: 10,
			pagination: {
				el: ".swiper-pagination",
				type: "progressbar",
			},
			navigation: {
				nextEl: ".swiper-nav-container .swiper-button-next",
				prevEl: ".swiper-nav-container .swiper-button-prev",
			  },
			slidesPerView: 4,
			cache: false,
			mousewheel: true,
			loop: false,
			center: true,
			slideToClickedSlide: true,
			freeMode: true,
			watchSlidesProgress: true,
			autoplay: false,
		});
	},
};

export default productSwiper;
